import { StatusBadge } from "@/components/StatusBadge";
import { formatDateTime } from "@/lib/helpers";

// Student Detail -> "Lesson History" card. Extracted from StudentDetail.js
// (props-driven, no behavior change).
export const LessonHistoryCard = ({ appointments }) => (
  <section className="rounded-[var(--radius)] border bg-card p-4 sm:p-5 space-y-3" data-testid="lesson-history-card">
    <h2 className="font-semibold font-heading">Lesson History</h2>
    {appointments.length === 0 ? (
      <p className="text-sm text-muted-foreground">No lessons yet.</p>
    ) : (
      <div className="divide-y">
        {appointments.map((a) => (
          <div key={a.id} className="flex items-center justify-between py-2" data-testid="student-lesson-history-row">
            <div>
              <p className="text-sm font-medium">{formatDateTime(a.start_time)}</p>
              <p className="text-xs text-muted-foreground">Instructor: {a.instructor_name}{a.instructor_notes ? ` — ${a.instructor_notes}` : ""}</p>
            </div>
            <StatusBadge status={a.status} />
          </div>
        ))}
      </div>
    )}
  </section>
);
